import React from 'react';

const HomeIcon = () => {
	return (
		<svg className="w-7 h-7 lg:w-6 lg:h-6" width="30px" height="30px" viewBox="0 0 24 24">
			<g
				className="icon-tabler"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.3"
				strokeLinecap="round"
				strokeLinejoin="miter"
			>
				<path d="M19 8.71l-5.333-4.148a2.666 2.666 0 0 0-3.274 0L5.059 8.71a2.665 2.665 0 0 0-1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.2c0-.823-.38-1.6-1.03-2.105"></path>
				<path d="M16 15c-2.21 1.333-5.792 1.333-8 0"></path>
			</g>
		</svg>
	);
};

export default HomeIcon;
